import React from 'react';
import Panel from '../../components/atom/Panel';
import WeatherIcon from '../atom/WeatherIcon';
import Icon from '../atom/Icon';
import './HourlyForecast.css';

const HourlyForecast = ({ data }) => {
//{ hour: "18:00", weathericon: "snow", hourWeather: 18, hourRain: 10 },

    return(
        <div className='mini-hourly-forecast-container'>
            <div className='hours'>{data.hour}</div>
            <Panel className="Panel">
                <div><WeatherIcon type={data.weathericon} className="weatherIcon" /></div>
                <div className="text-hourlyForecast" >{data.hourWeather}°</div>
                <div className='container'><Icon name="humidity"className="weatherIcon rainy" /></div>
                <div className="text-hourlyForecast" >{data.hourRain}%</div>
            </Panel>
        </div>
    );
};

export default HourlyForecast;